import { useT } from '@hooks';
import React, { useState, useEffect } from 'react';
import s from './index.module.scss';

const Timer = () => {
	const { T } = useT();
	const timerTime = 20; // minutes
	const initialTime = timerTime * 60;
	const [time, setTime] = useState(initialTime);

	useEffect(() => {
		const timer = setInterval(() => {
			if (time > 0) {
				setTime(time - 1);
			} else {
				clearInterval(timer);
				// console.log('Timer expired');
			}
		}, 1000);

		return () => {
			clearInterval(timer);
		};
	}, [time]);

	const minutes = sec => {
		const minutesValue = Math.floor(sec / 60);
		return `${String(minutesValue).padStart(2, '0')}`;
	};

	const seconds = sec => {
		const secondsValue = sec % 60;
		return `${String(secondsValue).padStart(2, '0')}`;
	};

	return (
		<div className={s.timerWrapper}>
			<p className={s.timerText}>{T('timer_text_1')}</p>
			<div className={s.timerTime}>
				<div className={s.timerCell}>
					<div className={s.timerCellNumber}>00</div>
					<div className={s.timerCellText}>{T('timer_text_4')}</div>
				</div>
				<div className={s.timerCellDivider}>:</div>
				<div className={s.timerCell}>
					<div className={s.timerCellNumber}>{minutes(time)}</div>
					<div className={s.timerCellText}>{T('timer_text_2')}</div>
				</div>
				<div className={s.timerCellDivider}>:</div>
				<div className={s.timerCell}>
					<div className={s.timerCellNumber}>{seconds(time)}</div>
					<div className={s.timerCellText}>{T('timer_text_3')}</div>
				</div>
			</div>
		</div>
	);
};

export default Timer;
